import { render, staticRenderFns } from "./CallSeverDialog.vue?vue&type=template&id=60121c9a&scoped=true&"
import script from "./CallSeverDialog.vue?vue&type=script&lang=js&"
export * from "./CallSeverDialog.vue?vue&type=script&lang=js&"
import style0 from "./CallSeverDialog.vue?vue&type=style&index=0&id=60121c9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60121c9a",
  null
  
)

export default component.exports